.activeBtn {
	background-color: var(--elevation-medium);
}

.dropdown {
	position: absolute;
	width: fit-content;
	max-width: 400px;
	border: 1px solid var(--border-primary);
	border-radius: 6px;
	background-color: var(--elevation-default);
	outline: none;
	max-height: 260px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.dropdown * {
	outline: none;
}
